(function (angular) {

    angular.module('app').run([
        '$rootScope', '$uibModal', '$uibModalStack', function ($rootScope, $uibModal, $uibModalStack) {

            //$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
            //});

            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options) {

                $uibModalStack.dismissAll('route change');

                setTimeout(function () {
                    $('[autofocus]').focus();
                    $('body').removeClass('modal-open').removeClass('scroll-lock');
                    window.scroll(0, 0);
                });

            });

            if (typeof $uibModal.openOrig === 'undefined' && $('body').hasClass('ios')) {
                $uibModal.openOrig = $uibModal.open;
                $uibModal.open = function (args) {
                    setTimeout(function () {
                        window.scroll(0, 0);
                        if ($('[autofocus]').length > 0) {
                            if ($(window).width() > $(window).height() && $('[autofocus]').position().top > ($(window).height() / 5)) {
                                window.scrollTo(0, $('[autofocus]').position().top);
                            }
                            else if ($(window).width() < $(window).height() && $('[autofocus]').position().top > (($(window).height() / 4) * 2)) {
                                window.scrollTo(0, $('[autofocus]').position().top);
                            }
                        }
                    }, 250);

                    return $uibModal.openOrig(args);
                };
            }
        }]);

})(angular);